import React, { useState } from 'react';
import Dialog from '@dashboard/components/Dialog';
import { Input } from '@dashboard/components/ui/input';

interface Props {
  open: boolean;
  email: string;
  pending?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteStaffDialog: React.FC<Props> = ({ open, email, pending, onCancel, onConfirm }) => {
  const [typed, setTyped] = useState('');

  const canConfirm = typed.trim().toLowerCase() === email.trim().toLowerCase();

  return (
    <Dialog
      open={open}
      onCancel={pending ? undefined : onCancel}
      size="md"
      title="Delete staff member?"
      description="This removes this staff member from all events."
      cancelButton={{
        label: 'Cancel',
        appearance: 'link',
        disabled: pending,
      }}
      confirmButton={{
        label: pending ? 'Deleting…' : 'Delete',
        appearance: 'primary',
        disabled: !canConfirm || pending,
        onClick: onConfirm,
      }}
    >
      <div className="space-y-2">
        <label className="text-sm text-muted-foreground" htmlFor="delete-confirm-email">
          Type <span className="font-mono text-foreground">{email}</span> to confirm:
        </label>
        <Input
          id="delete-confirm-email"
          // Unique `name` + autoComplete="off" stops Chrome from matching
          // the saved-email autofill list against this field.
          name="confirm-staff-email-delete"
          autoComplete="off"
          autoFocus
          value={typed}
          onChange={e => setTyped(e.target.value)}
          placeholder={email}
          disabled={pending}
        />
      </div>
    </Dialog>
  );
};

export default DeleteStaffDialog;
